import { create } from 'zustand';
import { produce } from 'immer';
const initialState = {
    settings: null,
};
export const useUserSettingsStore = create((set, get) => ({
    ...initialState,
    setSettings: (settings) => set({ settings }),
    updateSettings: (settingsUpdate) => set(produce((state) => {
        if (state.settings) {
            // Merge updates into existing settings
            Object.assign(state.settings, settingsUpdate);
        }
        else {
            // If settings is somehow null, just set the partial as it will likely be replaced by server data
            state.settings = settingsUpdate;
        }
    })),
    reset: () => set(initialState),
}));
export const selectUserSettings = (state) => state.settings;
